import $ from 'jquery';

$(document).on('click', '.browse-toggle-filters', function(e) {
  e.preventDefault();
  $('.browse').toggleClass('browse-filtered');
});
